import { createSlice } from "@reduxjs/toolkit";
import i18next from "i18next";

const langObjectFromString = (lang) => {
    const value = String(lang || "").toLowerCase().startsWith("ar") ? "ar" : "en";
    const label = value === "ar" ? i18next.t("language.ar") : i18next.t("language.en");
    return value === "ar"
        ? { label, value: "ar" }
        : { label, value: "en" };
};

const getPreferredLang = () => {
    try {
        const stored = localStorage.getItem("preferredLang");
        if (stored) return stored;
        const fromI18n = localStorage.getItem("i18nextLng");
        if (fromI18n) return fromI18n;
        const fromAppLang = localStorage.getItem("appLang");
        if (fromAppLang) return fromAppLang;
        return null;
    } catch (error) {
        return null;
    }
};

const getLangFromStorage = () => {
    const preferred = getPreferredLang();
    if (preferred) return langObjectFromString(preferred);
    return { label: i18next.t("language.en"), value: "en" };
};

const langSlice = createSlice({
    name: "lang",
    initialState: getLangFromStorage(),
    reducers: {
        setLang: (state, action) => {
            const payloadValue = action?.payload?.value;
            const payloadLabel = action?.payload?.label;
            if (payloadValue) {
                const normalized = langObjectFromString(payloadValue);
                state.label = payloadLabel || normalized.label;
                state.value = normalized.value;
                try {
                    localStorage.setItem("preferredLang", normalized.value);
                } catch (error) {
                }
                return;
            }
            const preferred = getPreferredLang();
            if (preferred) {
                const normalized = langObjectFromString(preferred);
                state.label = normalized.label;
                state.value = normalized.value;
            }
        }
    }
});

export const { setLang } = langSlice.actions;
export default langSlice.reducer
